import { StateSchema } from "@/app/providers/StoreProvider";

export const getResponseFormIsLoading = (state: StateSchema) => state.readingDetails?.responseFormIsLoading || false;
export const getResponseFormData = (state: StateSchema) => state.readingDetails?.responseForm;
export const getResponseFormError = (state: StateSchema) => state.readingDetails?.responseFormError;
